import React, { useState, useEffect ,useRef} from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import * as XLSX from 'xlsx';

const TimeSeriesChart = () => {
  // Estado para almacenar los datos ingresados
  const [data, setData] = useState([]);
  // Duración en segundos de la ventana de tiempo visible en el gráfico
  const [duration, setDuration] = useState(60);
  // Estado para almacenar el tiempo actual
  const [currentTime, setCurrentTime] = useState(Date.now());
  // Controla si la actualización del gráfico está en reproducción o en pausa
  const [isPlaying, setIsPlaying] = useState(false);
  // Buffer para almacenar la entrada del usuario antes de ser procesada
  const [inputBuffer, setInputBuffer] = useState('');
  const chartContainerRef = useRef(null);

  // Limpiar buffer al pausar/detener
  useEffect(() => {
    if (!isPlaying) setInputBuffer('');
  }, [isPlaying]);
  // Efecto para actualizar el tiempo actual cada segundo si el gráfico está en reproducción
  useEffect(() => {
    let interval;
    if (isPlaying) {
      interval = setInterval(() => {
        setCurrentTime(Date.now());
      }, 1000);
       // Enfocar el contenedor del gráfico al iniciar
       chartContainerRef.current?.focus();
    }
    return () => clearInterval(interval);
  }, [isPlaying]);

  // Efecto para capturar las entradas del teclado y almacenarlas en el buffer
  useEffect(() => {
    const handleKeyPress = (e) => {
      // Si la tecla presionada es un número, se añade al buffer
      if (!isPlaying) return;
      if (e.key >= '0' && e.key <= '9') {
        setInputBuffer(prev => prev + e.key);
      }     
      // Si se presiona Enter, se guarda el valor en los datos y se limpia el buffer
      if (e.key === 'Enter' && inputBuffer) {
        const newValue = parseInt(inputBuffer, 10);
        setData(prev => [...prev, {
          time: Date.now(),
          value: newValue
        }]);
        setInputBuffer('');
      }
      
      // Si se presiona Backspace, se borra el último número ingresado
      if (e.key === 'Backspace') {
        setInputBuffer(prev => prev.slice(0, -1));
      }
    };

    window.addEventListener('keydown', handleKeyPress);
    return () => window.removeEventListener('keydown', handleKeyPress);
  }, [inputBuffer,isPlaying]);

  //-----------------------------------------------------------
  const handlePlayPause = () => {
    const newState = !isPlaying;
    setIsPlaying(newState);
    if (newState) {
      setTimeout(() => {
        chartContainerRef.current?.focus();
      }, 50);
    }
  };
  // Función para detener la reproducción y reiniciar los datos
  const handleStop = () => {
    setIsPlaying(false);
    setCurrentTime(Date.now());
    setData([]);
    //setInputBuffer(''); // Limpiar buffer al detener
  };

  // Función para exportar los datos a un archivo Excel
  const handleDownloadExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(
      data.map(item => ({
        Hora: new Date(item.time).toLocaleTimeString(),
        Valor: item.value
      }))
    );
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Datos");
    XLSX.writeFile(workbook, "datos.xlsx");
  };

   // Datos vacíos cuando no está activo
   const filteredData = isPlaying 
   ? data.filter(item => item.time >= currentTime - duration * 1000)
   : [];

  // Obtener el dominio del eje Y en función de los valores visibles
  const getYDomain = () => {
    if (filteredData.length === 0) return [0, 10];
    const values = filteredData.map(d => d.value);
    const min = Math.min(...values);
    const max = Math.max(...values);
    return [Math.min(min - 1, 0), max + 1];
  };
  //código define en el grafico hor, minuti,segundos dos digitos lo mismo que codigo abajo
  /*const formatTime = (unixTime) => {
    const date = new Date(unixTime);
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    return `${hours}:${minutes}:${seconds}`;
  };*/
  const formatTime = (unixTime) => {
    const date = new Date(unixTime);
    return date.toLocaleTimeString('es-ES', {
      hour12: false,
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    });
  };

  return (
    <div style={{ padding: '20px' }}>
      <div style={{ marginBottom: '20px', display: 'flex', gap: '10px',flexWrap:'wrap' }}>
        {/* Botón para pausar o reanudar la actualización del gráfico */}
        <button 
          onClick={handlePlayPause}
          style={{
            backgroundColor: isPlaying ? '#4CAF50' : 'blue',
            border: '2px solid #4CAF50'
            
          }}
        >
          {isPlaying ? '⏸ Pause' : '▶ Play'}
        </button>
        {/* Botón para detener y reiniciar el gráfico */}
        <button onClick={handleStop}>⏹ Stop</button>
        {/* Botón para descargar los datos en Excel */}
        <button 
          onClick={handleDownloadExcel}
          disabled={data.length === 0}
          style={{
            cursor: data.length === 0 ? 'not-allowed' : 'pointer',
            backgroundColor: data.length === 0 ? 'green' : 'blue',
            opacity: data.length === 0 ? 0.6 : 1
          }}
        >
          📥 Descargar Excel
        </button>
        
        {/* Entrada para ajustar la duración de la ventana de tiempo */}
        <label>
          Duración (s):
          <input
            type="number"
            value={duration}
            
            onChange={(e) => setDuration(Math.max(60, Math.floor(e.target.value / 60) * 60))}
            min="60"
            step="60"
            style={{ marginLeft: '10px', width: '60px' }}
          />
        </label>
        
        {/* Mostrar la entrada del usuario antes de enviarla */}
        <div>
          Entrada: <strong>{isPlaying ? (inputBuffer || '0'): '0'}</strong> 
            {isPlaying ? (
              <span style={{ color: 'green', marginLeft: '8px' }}>(Activo)</span>
            ) : (
              <span style={{ color: 'red', marginLeft: '8px' }}>(Inactivo)</span>
            )}

           <div style={{ fontSize: '0.8em', color: '#666' }}>
              {isPlaying && 'Enter para enviar, Backspace para borrar'}
            </div>
        </div>

      </div>
{/*---------------------------------------------------------------------------*/}
<div 
        ref={chartContainerRef}
        tabIndex={-1}
        style={{
          outline: isPlaying ? '2px solid #4CAF50' : '#f0f0f0',
          borderRadius: '8px',
          transition: 'outline 0.3s ease'
        }}
      >      
{/*---------------------------------------------------------------------------*/}

      {/* Contenedor del gráfico de línea */}
      <ResponsiveContainer width="100%" height={400}>
        <LineChart data={filteredData}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis
            dataKey="time"
            type="number"
            domain={[currentTime, currentTime + duration * 1000]}
            tickFormatter={formatTime}
          />
          <YAxis domain={getYDomain()} />
          <Tooltip
           labelFormatter={formatTime}
          />
          <Line
            type="monotone"
            dataKey="value"
            stroke="#8884d8"
            dot={false}
            isAnimationActive={false}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
    </div>
  );
};

export default TimeSeriesChart;
